<template>
  <span>Success</span>
</template>

<script>
export default {
  name: "notification-template"
};
</script>
